import React from 'react';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';

const EmailServiceDetailsTab = ({
  formData,
  handleInputChange,
  readOnly = false,
  templateTypes = [],
  loadingTemplateTypes = false,
}) => {

  if (readOnly) {
    return (
      <div className='w-100 mt-5 email-view'>
        <div className='row'>
          <div className='col-md-6 mb-4'>
            <strong>Email Template Name</strong>
            <div className='view-field-value'>{formData?.name?.value || '—'}</div>
          </div>
          <div className='col-md-6 mb-4'>
            <strong>Template Type</strong>
            <div className='view-field-value'>{formData?.templateType?.value || '—'}</div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-6 mb-4'>
            <strong>From Name</strong>
            <div className='view-field-value'>{formData?.fromName?.value || '—'}</div>
          </div>
          <div className='col-md-6 mb-4'>
            <strong>From Address</strong>
            <div className='view-field-value'>{formData?.fromAddress?.value || '—'}</div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12 mb-4'>
            <strong>CC</strong>
            <div className='view-field-value'>{formData?.cc?.value || '—'}</div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12 mb-4'>
            <strong>BCC</strong>
            <div className='view-field-value'>{formData?.bcc?.value || '—'}</div>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12 mb-4'>
            <strong>Subject Line</strong>
            <div className='view-field-value' style={{ whiteSpace: 'pre-wrap' }}>
              {formData?.subject?.value || '—'}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='w-100 mt-5'>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.name}
            handleInputChange={(e) => handleInputChange({ name: e })}
            endAdornment={true}
            multiline={true}
            maxLength={100}
            characterCount={true}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomSelect
            item={formData.templateType}
            handleInputChange={(e) => handleInputChange({ templateType: e })}
            options={templateTypes}
            labelField='keyword'
            valueField='keyword'
            disabled={loadingTemplateTypes}
            isSearchable={true}
            searchPlaceholder='Search template type...'
            hideNullOption={true}
          />
        </div>
      </div>

      <div className='row'>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.fromName}
            handleInputChange={(e) => handleInputChange({ fromName: e })}
            maxLength={36}
            endAdornment={true}
            characterCount={true}
            multiline={true}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <CustomTextField
            item={formData.fromAddress}
            handleInputChange={(e) => handleInputChange({ fromAddress: e })}
          />
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12 mb-3'>
          <CustomTextField
            item={formData.cc}
            handleInputChange={(e) => handleInputChange({ cc: e })}
            characterCount={true}
          />
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12 mb-3'>
          <CustomTextField
            item={formData.bcc}
            handleInputChange={(e) => handleInputChange({ bcc: e })}
            characterCount={true}
          />
        </div>
      </div>

      <div className='row'>
        <div className='col-md-12 mb-3'>
          <CustomTextField
            item={formData.subject}
            handleInputChange={(e) => handleInputChange({ subject: e })}
            maxLength={100}
            multiline={true}
            endAdornment={true}
            characterCount={true}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailServiceDetailsTab;
